import { Radio } from "lucide-react";
import { VIDEOS } from "@/data/site";
import { Reveal, SectionHead } from "./Reveal";
import { VideoFrame } from "./Film";

export const ShowPilot = () => (
  <section id="on-air" className="relative py-28 lg:py-40 bg-ink overflow-hidden" data-testid="show-section">
    <div className="pointer-events-none absolute right-[-10%] bottom-[-20%] h-[520px] w-[520px] rounded-full bg-gold/10 blur-[160px]" />
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12 grid lg:grid-cols-12 gap-14 items-center">
      <div className="lg:col-span-5 order-2 lg:order-1">
        <Reveal>
          <span className="inline-flex items-center gap-2 border border-gold/40 text-gold font-mono text-[10px] tracking-[0.28em] uppercase px-3 py-1.5" data-testid="show-badge">
            <Radio size={11} /> Pilot Episode
          </span>
        </Reveal>
        <SectionHead
          index="04"
          eyebrow="On Air"
          title={<>Mortgages for <span className="text-gold">Black &amp; Brown</span> Folk</>}
          className="mt-6"
        />
        <Reveal delay={0.2}>
          <p className="mt-8 text-ivory/60 leading-relaxed">
            The pilot for the cable show hosted by Kenneth Bossard — a plain-language conversation about mortgage
            financing, credit and homeownership for communities historically left out of the wealth-building story.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <ul className="mt-8 space-y-3 text-sm text-ivory/70">
            {["Understanding qualification & credit", "Financing paths beyond the conventional", "From first home to first investment"].map((t) => (
              <li key={t} className="flex items-center gap-3">
                <span className="h-px w-6 bg-gold/70" /> {t}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
      <div className="lg:col-span-7 order-1 lg:order-2">
        <VideoFrame src={VIDEOS.pilot} title="Mortgages for Black and Brown Folk — Pilot" testId="show-video" />
      </div>
    </div>
  </section>
);
